import React from 'react';
import ReactPlaceholder from 'react-placeholder';

const ShippingLoader = () => {
  return (
    <div className="shipping-loader">
      <ReactPlaceholder
        showLoadingAnimation
        color="#f5f5f5"
        type="rect"
        style={{ width: 32, height: 26 }}
      />
      <ReactPlaceholder
        showLoadingAnimation
        color="#f5f5f5"
        type="text"
        rows={2}
        style={{ width: 256, height: 26 }}
      />
    </div>
  );
};

export default ShippingLoader;
